import React from 'react';
import { Input, Textarea, Select, Button, PaperClip, DatePicker } from 'components';
import { ProfileService, AuthService } from 'services';
import moment from 'moment';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { Globals, Constants } from 'utils';
import { RouteComponentProps } from 'react-router-dom';
import { PhoneIcon, WebIcon, InstagramIcon, FacebookIcon, LocationIcon, TimeIcon, AddIcon, TrashIcon } from 'assets/icons';
import { WhiteImage } from 'assets/img';

const TABS = {
	DATA: 1,
	SOCIAL: 2,
	PASSWORD: 3
}

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

class Profile extends React.Component<Props> {

	state = {
		form: {
			name: '',
	        email: '',
	        document_type_id: '',
			document: '',
			address: '',
			phonecode_id: '',
			phone: '',
	        web: '',
	        instagram: '',
	        facebook: '',
	        instagram_url: '',
	        facebook_url: '',
	        password: '',
	        password_confirmation: '',
	        photo: '',
	        schedule_since: '',
	        schedule_until: '',
	        speciality_id: '',
	        state_id: '',
	        city_id: ''
		},
		cities: [],
		step: TABS.DATA,
		document_types: [],
		states: [],
		phonecodes: [],
		user: null,
		specialities: [],
		establishments: [{
			name: '',
			address: '',
			schedule_since: '',
			schedule_until: ''
		}]
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Mis Datos',
				onBack: null
			}
		});

		this.props.dispatch({
			type: 'SET_SUBHEADER',
			payload: {
				title: ''
			}
		});

		this.load();
	}

	load = async () => {
		const res: any = await ProfileService.get({
			user_id: this.props.user.id
		});
		this.setState({
			document_types: res.document_types,
			phonecodes: res.phonecodes,
			specialities: res.specialities,
			user: res.user,
			states: res.states,
			form: {
				...this.state.form,
				name: res.user.name,
		        email: res.user.email,
		        document_type_id: res.user.document_type_id || (res.document_types.length > 0 ? res.document_types[0].id : ''),
				phonecode_id: res.user.phonecode_id || (res.phonecodes.length > 0 ? res.phonecodes[0].id : ''),
				document: res.user.document || '',
				phone: res.user.phone || '',
				address: res.user.address || '',
				web: res.user.web || '',
				instagram: res.user.instagram || '',
				facebook: res.user.facebook || '',
				instagram_url: res.user.instagram_url || '',
				facebook_url: res.user.facebook_url || '',
				schedule_since: res.user.schedule_since ? moment(res.user.schedule_since,'HH:mm:ss').toDate() : '',
				schedule_until: res.user.schedule_until ? moment(res.user.schedule_until,'HH:mm:ss').toDate() : '',
				speciality_id: res.user?.speciality_id || '',
				state_id: res.user?.state_id || '',
				city_id: res.user?.city_id || ''
			},
			establishments: res.user?.establishments?.map((item: any) => {
				return {
					...item,
					schedule_since: item.schedule_since ? moment(item.schedule_since,'HH:mm:ss').toDate() : '',
					schedule_until: item.schedule_until ? moment(item.schedule_until,'HH:mm:ss').toDate() : '',
				}
			}) || []
		},() => this.getCities());
	}

	submit = async (e: any) => {
		e.preventDefault();
		const res: any = await ProfileService.update({
			user_id: this.props.user.id,
			...this.state.form,
			hasFile: true,
			// @ts-ignore,
			photo: this.state.form.photo?.value || '',
			schedule_since: this.state.form.schedule_since && moment(this.state.form.schedule_since).format('HH:mm'),
			schedule_until: this.state.form.schedule_until && moment(this.state.form.schedule_until).format('HH:mm'),
			establishments: JSON.stringify(this.state.establishments.map((i: any) => {
				return {
					...i,
					schedule_since: i.schedule_since && moment(i.schedule_since).format('HH:mm'),
					schedule_until: i.schedule_until && moment(i.schedule_until).format('HH:mm'),
				}
			}))
		});
		Globals.showSuccess("Se ha actualizado el perfil correctamente");
		this.props.dispatch({
			type: 'SET_USER',
			payload: res.user
		});
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	setStep = (step: number) => {
		this.setState({
			step
		});
	}

	changeEstablishments = (index: number, e: any) => {
		let establishments: any = [...this.state.establishments];
		establishments[index][e.target.name] = e.target.value;
		this.setState({
			establishments
		});
	}

	getCities = async () => {
		const res: any = await AuthService.getCities({
			state_id: this.state.form.state_id
		});
		this.setState({
			cities: res.cities
		});
	}
	
	render() {
		const phonecode: any = this.state.phonecodes.find((i: any) => i.id == this.state.form.phonecode_id);
		const document_type: any = this.state.document_types.find((i: any) => i.id == this.state.form.document_type_id);

		return (
			<div id="profile">
				<form className="row" onSubmit={ this.submit }>	
					<div className="col-md-3">
						<div className="container-data">
							<div className="container-avatar">
								<div className="container-image">
									<PaperClip
										className="paperclip-image"
										value={ this.state.form.photo }
										onChange={ (e: any) => {
											this.setState({
												form: {
													...this.state.form,
													photo: e.target
												}
											})
										} }>
										{/*
										// @ts-ignore */}
										<img className={ `selected-image ${ (this.state.form.photo || this.state.user?.photo) ? '' : 'inactive' }` } src={ this.state.form.photo?.dataURL || (this.state.user?.photo ? (Constants.BASE_STORAGE + this.state.user?.photo) : WhiteImage) } />
									</PaperClip>
								</div>
								<h4>{ this.state.form.name }</h4>
								<h5>{ document_type?.name }{ this.state.form.document }</h5>
							</div>
							<div className="item-profile">
								<img src={ PhoneIcon } />
								<p>{ phonecode?.name }-{ this.state.form.phone }</p>
							</div>
							<div className="item-profile">
								<img src={ WebIcon } />
								<p>{ this.state.form.web }</p>
							</div>
							<div className="item-profile">
								<img src={ InstagramIcon } />
								<p>{ this.state.form.instagram }</p>
							</div>
							<div className="item-profile">
								<img src={ FacebookIcon } />
								<p>{ this.state.form.facebook }</p>
							</div>
						</div>
					</div>
					<div className="col-md-9">
						<div className="container-form">
							<div className="container-tabs">
								<div className={ `tab ${ this.state.step == TABS.DATA ? 'active' : '' }` } onClick={ () => this.setStep(TABS.DATA) }>
									Datos
								</div>
								<div className={ `tab ${ this.state.step == TABS.SOCIAL ? 'active' : '' }` } onClick={ () => this.setStep(TABS.SOCIAL) }>
									Redes Sociales
								</div>
								<div className={ `tab ${ this.state.step == TABS.PASSWORD ? 'active' : '' }` } onClick={ () => this.setStep(TABS.PASSWORD) }>
									Contraseña
								</div>
								<div className="tab-flex"></div>
							</div>
							<div className="row">
								{
									this.state.step == TABS.DATA && (
										<div className="row col-12">
											<div className="col-md-6">
												<Input
													color="white"
													value={ this.state.form.name }
													name="name" 
													label="Nombre"
													onChange={ this.change } />
											</div>
											<div className="col-md-6">
												<Input
													color="white"
													value={ this.state.form.email }
													name="email" 
													label="Correo Electrónico"
													onChange={ this.change } />
											</div>
											<div className="col-md-6">
												<div className="container-select">
													<p className="label">Dirección</p>
													<div>
														<div className="container-icon">
															<img src={ LocationIcon } />
														</div>
														<Input
															color="white"
															value={ this.state.form.address }
															name="address" 
															placeholder="Dirección"
															onChange={ this.change } />
													</div>
												</div>
											</div>
											{
												this.props.user?.level_id == Constants.LEVELS.AFFILIATE && (
													<div className="col-md-6">
														<Select
															className="speciality_select"
															label="Especialidad"
															name="speciality_id"
															onChange={ this.change }
															value={ this.state.form.speciality_id }
															options={ this.state.specialities.map((i: any) => {
																return {
																	value: i.id,
																	label: i.name
																}
															}) } />
													</div>
												)
											}
											<div className="col-md-6">
												<div className="container-select">
													<p className="label">Tipo de Documento</p>
													<div>
														<Select
															className="document_type"
															name="document_type_id"
															onChange={ this.change }
															value={ this.state.form.document_type_id }
															options={ this.state.document_types.map((i: any) => {
																return {
																	value: i.id,
																	label: i.name
																}
															}) } />
														<Input
															type="number"
															color="white"
															value={ this.state.form.document }
															name="document" 
															placeholder="Documento"
															onChange={ this.change } />
													</div>
												</div>
											</div>
											{
												(this.props.user?.level_id == Constants.LEVELS.AFFILIATE || this.props.user?.level_id == Constants.LEVELS.SELLER) && (
													<React.Fragment>
														<div className="col-md-6">
															<Select
																className="speciality_select"
																label="Estado"
																name="state_id"
																onChange={ (e: any) => this.change(e,() => {
																	this.setState({
																		form: {
																			...this.state.form,
																			city_id: ''
																		}
																	},() => this.getCities());
																}) }
																value={ this.state.form.state_id }
																options={ this.state.states.map((i: any) => {
																	return {
																		value: i.id,
																		label: i.name
																	}
																}) } />
														</div>
														<div className="col-md-6">
															<Select
																className="speciality_select"
																label="Ciudad"
																disabled={ !this.state.form.state_id }
																name="city_id"
																onChange={ this.change }
																value={ this.state.form.city_id }
																options={ this.state.cities.map((i: any) => {
																	return {
																		value: i.id,
																		label: i.name
																	}
																}) } />
														</div>
													</React.Fragment>
												)
											}
											<div className="col-md-6">
												<div className="container-select">
													<p className="label">Teléfono</p>
													<div>
														<Select
															name="phonecode_id"
															onChange={ this.change }
															value={ this.state.form.phonecode_id }
															options={ this.state.phonecodes.map((i: any) => {
																return {
																	value: i.id,
																	label: i.name
																}
															}) } />
														<Input
															type="number"
															color="white"
															value={ this.state.form.phone }
															name="phone" 
															placeholder="Teléfono"
															onChange={ this.change } />
													</div>
												</div>
											</div>
											{
												this.props.user?.level_id == Constants.LEVELS.AFFILIATE && (
													<React.Fragment>
														<div className="col-12">
															<div className="row container-establishments">
																<div className="col-md-8">
																	<h4 className="title-establishments">Establecimientos donde presta servicio</h4>
																</div>
																<div className="col-md-4 text-right">
																	<Button className="btn-add" type="button" onClick={ () => {
																		let establishments: any = [...this.state.establishments];
																		establishments.push({
																			name: '',
																			address: '',
																			schedule_since: '',
																			schedule_until: ''
																		});
																		this.setState({
																			establishments
																		});
																	} }>
																		<img src={ AddIcon } /> 
																	</Button>
																</div>
															</div>
														</div>
														{
															this.state.establishments.map((item: any,index: number) => {
																return (
																	<div className="col-12 container-establishment-item">
																		<div className="row item-establishments">
																			<div className="col-md-5">
																				<Input
																					color="white"
																					value={ item.name }
																					name="name" 
																					placeholder="Nombre"
																					onChange={ (e: any) => {
																						this.changeEstablishments(index,e);
																					} } />
																			</div>
																			<div className="col-md-5">
																				<Input
																					color="white"
																					value={ item.address }
																					name="address" 
																					placeholder="Dirección"
																					onChange={ (e: any) => {
																						this.changeEstablishments(index,e);
																					} } />
																			</div>
																			<div className="col-md-2 text-center">
																				<Button className="btn-remove" type="button" onClick={ () => {
																					let establishments: any = [...this.state.establishments];
																					establishments.splice(index,1);
																					this.setState({
																						establishments
																					});
																				} }>
																					<img src={ TrashIcon } />
																				</Button>
																			</div>
																			<div className="col-md-12">
																				<p className="schedule-title">Horario</p>
																			</div>
																			<div className="col-md-5">
																				<DatePicker
																					label="Desde"
																					showTimeSelect={ true }
																					showTimeSelectOnly={ true }
																					timeCaption="Hora"
																					calendarIcon={ TimeIcon }
																					dateFormat="h:mm aa"
																					onChange={ (text: string) => {
																						this.changeEstablishments(index,{
																							target: {
																								name: 'schedule_since',
																								value: text
																							}
																						});
																					} }
																					value={ item.schedule_since }
																				/>
																			</div>
																			<div className="col-md-5">
																				<DatePicker
																					label="Hasta"
																					showTimeSelect={ true }
																					showTimeSelectOnly={ true }
																					timeCaption="Hora"
																					calendarIcon={ TimeIcon }
																					dateFormat="h:mm aa"
																					onChange={ (text: string) => {
																						this.changeEstablishments(index,{
																							target: {
																								name: 'schedule_until',
																								value: text
																							}
																						});
																					} }
																					value={ item.schedule_until }
																				/>
																			</div>
																		</div>
																	</div>
																)
															})
														}
													</React.Fragment>
												)
											}
											{
												this.props.user?.level_id == Constants.LEVELS.SELLER && (
													<React.Fragment>
														<div className="col-md-12">
															<p className="schedule-title">Horario</p>
														</div>
														<div className="col-md-4">
															<DatePicker
																label="Desde"
																showTimeSelect={ true }
																showTimeSelectOnly={ true }
																timeCaption="Hora"
																calendarIcon={ TimeIcon }
																dateFormat="h:mm aa"
																onChange={ (text: string) => {
																	this.change({
																		target: {
																			value: text,
																			name: 'schedule_since'
																		}
																	});
																} }
																value={ this.state.form.schedule_since }
															/>
														</div>
														<div className="col-md-4">
															<DatePicker
																label="Hasta"
																showTimeSelect={ true }
																showTimeSelectOnly={ true }
																timeCaption="Hora"
																calendarIcon={ TimeIcon }
																dateFormat="h:mm aa"
																onChange={ (text: string) => {
																	this.change({
																		target: {
																			value: text,
																			name: 'schedule_until'
																		}
																	});
																} }
																value={ this.state.form.schedule_until }
															/>
														</div>
													</React.Fragment>
												)
											}
										</div>
									)
								}			
								{
									this.state.step == TABS.SOCIAL && (
										<div className="row col-12">
											<div className="col-md-12">
												<Input
													color="white"
													value={ this.state.form.web }
													name="web" 
													placeholder="https://"
													label="Web"
													onChange={ this.change } />
											</div>
											<div className="col-md-6">
												<Input
													color="white"
													value={ this.state.form.facebook }
													name="facebook" 
													placeholder="Facebook"
													label="Facebook"
													onChange={ this.change } />
											</div>
											<div className="col-md-6">
												<Input
													color="white"
													value={ this.state.form.facebook_url }
													name="facebook_url" 
													placeholder="Facebook (URL)"
													label="Facebook (URL)"
													onChange={ this.change } />
											</div>
											<div className="col-md-6">
												<Input
													color="white"
													value={ this.state.form.instagram }
													name="instagram" 
													placeholder="Instagram"
													label="Instagram"
													onChange={ this.change } />
											</div>
											<div className="col-md-6">
												<Input
													color="white"
													value={ this.state.form.instagram_url }
													name="instagram_url" 
													placeholder="Instagram (URL)"
													label="Instagram (URL)"
													onChange={ this.change } />
											</div>
										</div>
									)
								}
								{
									this.state.step == TABS.PASSWORD && (
										<div className="row col-12">
											<div className="col-md-6">
												<Input
													type="password"
													color="white"
													value={ this.state.form.password }
													name="password" 
													label="Nueva contraseña"
													placeholder="Nueva contraseña"
													onChange={ this.change } />
											</div>
											<div className="col-md-6">
												<Input
													type="password"
													color="white"
													value={ this.state.form.password_confirmation }
													name="password_confirmation" 
													label="Repetir contraseña"
													placeholder="Repetir contraseña"
													onChange={ this.change } />
											</div>
										</div>
									)
								}
								<div className="col-12">
									<Button type="submit">
										Guardar
									</Button>													
								</div>
							</div>
						</div>
					</div>
				</form>
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(Profile);